import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    d: 'M1.5 3C0.67125 3 0 3.67197 0 4.49994V19.4993C0 20.328 0.67125 21 1.5 21H22.5007C23.3287 21 24 20.328 24 19.4993V4.49994C24 3.67197 23.3287 3 22.5007 3H1.5Z',
                    fill: '#2B2970',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M14.0085 9.74973C12.6623 9.74973 11.7128 10.4284 11.7068 11.3989C11.7 12.1166 12.3847 12.5164 12.9 12.7548C13.4302 12.9993 13.6087 13.1561 13.6057 13.3743C13.6027 13.7096 13.1828 13.8626 12.7913 13.8626C12.2835 13.8746 11.7825 13.7568 11.334 13.5213L11.1428 14.6388C11.628 14.818 12.1425 14.9088 12.6592 14.905C14.091 14.905 15.0203 14.236 15.0308 13.1988C15.0338 12.6304 14.6707 12.1976 13.8847 11.8406C13.4092 11.6104 13.1175 11.4559 13.1205 11.2219C13.1205 11.0134 13.368 10.7922 13.9035 10.7922C14.298 10.7817 14.6895 10.8679 15.0443 11.0412L15.2295 9.95822C14.847 9.82022 14.4435 9.74973 14.0363 9.74973C14.0273 9.74973 14.0175 9.74973 14.0085 9.74973ZM5.21325 9.83597H3.01725L3 9.94022C3.49875 10.058 3.98025 10.2425 4.431 10.4884L5.64075 14.8278H7.08225L9.22575 9.84122L7.78425 9.83897L6.45 13.2461L6.30825 12.5539L5.8305 10.2582C5.7645 10.0055 5.5365 9.83222 5.28 9.83222C5.2575 9.83222 5.235 9.83372 5.21325 9.83597ZM16.9523 10.2545L14.9302 14.8308H16.3605C16.3605 14.8308 16.5945 14.2158 16.6478 14.0808H18.3907C18.432 14.2563 18.5573 14.83 18.5573 14.83H19.8203L18.7185 9.84047H17.6663C17.637 9.83672 17.6077 9.83447 17.5792 9.83447C17.3077 9.83447 17.058 9.99796 16.9523 10.2545ZM17.7623 11.1867C17.946 12.0484 17.7675 11.2129 18.1695 13.0608H17.0392C17.0955 12.9161 17.6513 11.4897 17.7623 11.1867ZM9.777 9.83522L8.92575 14.8308H10.287L11.1397 9.83522H9.777Z',
                    fill: 'white',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: false })) })));
};
const VisaCardColored = React.forwardRef(IconComponent);
VisaCardColored.displayName = 'VisaCardColored';

export { VisaCardColored };
